<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_numericalNetwork') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
            span(slot="value") {{$i18n.t('common.common_gameSetting_digitCapacity' + parameters.difficult.value)}}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_visionFieldSpeed') }}
            span(slot="value") {{ parameters.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
    };
</script>
